import { useHomeworkStore } from "@/stores/models/homework";
import { useAuthUserStore } from "@/stores/authUser";

export default async function homeworkExists({ to }) {
    let exists = false;
    let homeworkId = to.params.homeworkId;
    if (homeworkId) {
        try {
            const homeworkStore = useHomeworkStore();
            const authUserStore = useAuthUserStore();
            const loggedInUser = authUserStore.user;
            await homeworkStore.fetchItem({
                query: { id: homeworkId },
                key: "VIEW_HOMEWORK",
                extra: { account_id: loggedInUser?.account_id }
            });

            exists = true;
        } catch (err) {
            exists = false;
        }
    }

    if (!exists) {
        return {
            name: "Not Found"
        };
    }
}
